import type { ProviderOptionAdminRow } from '../api'

/** VistoeraTASK-00334 — enabled first, default first within enabled, then stable order. */
export function sortProviderOptionsForAdmin(rows: ProviderOptionAdminRow[]): ProviderOptionAdminRow[] {
  return [...rows].sort((a, b) => {
    if (a.enabled !== b.enabled) {
      return a.enabled ? -1 : 1
    }
    if (a.enabled && b.enabled && a.is_default !== b.is_default) {
      return a.is_default ? -1 : 1
    }
    const orderA = a.sort_order ?? 0
    const orderB = b.sort_order ?? 0
    if (orderA !== orderB) {
      return orderA - orderB
    }
    return a.id.localeCompare(b.id)
  })
}
